// extracted by mini-css-extract-plugin
export default {"root":"CustomItem_root__njQSq","checkbox":"CustomItem_checkbox__3LTyE","selected":"CustomItem_selected__FgokE"};